import ZFSS_ErrorHandler from './handler';

const ErrorHandler = new ZFSS_ErrorHandler();

export default ErrorHandler;
